import { Component, OnInit, ChangeDetectionStrategy, Input, ElementRef, ViewChild } from '@angular/core';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';
import { Router } from '@angular/router';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { PrestadorModel } from 'src/app/shared/models/prestador.model';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { DetalleSolicitudService } from '../../containers/bandeja-principal/funcionario/detalle-solicitud/detalle-solicitud.service';
import { ListItemSimplified } from 'src/app/shared/models/ListItemSimplified.model';
import { EstadosSolicitud } from 'src/app/shared/enumeraciones/estados-solicitud.enum';
import { SolicitudesService } from '../../containers/bandeja-principal/funcionario/solicitudes/solicitudes.service';

@Component({
	selector: 'app-modal-suspencion',
	templateUrl: './modal-suspencion.component.html',
	styleUrls: ['./modal-suspencion.component.scss']
})
export class ModalSuspencionComponent implements OnInit {
	@Input()
	estados: Array<any>;
	@Input()
	descripcion: string;
	selectedStatusId: string;
	headers: Array<string>;
	modalGenerico: ModalGenericoModel;
	formDatos: FormGroup;
	estado_devuelto = EstadosSolicitud.Devuelto;
	datosRnt: Array<any> = [];
	@ViewChild('texto') texto: ElementRef;
	constructor(private activeModal: NgbActiveModal, private formBuilder: FormBuilder, private modalService: NgbModal,
		private solicitudServices: SolicitudesService) {
		this.datosRnt = [];
	}

	ngOnInit() {
		this.modalGenerico = {
			titulo: 'Suspensión por autoridad competente'
		};
		this.formulario();
		this.headers = ['Número RNT', 'Establecimiento', 'Estado RNT', 'Acciones'];
	}

	formulario() {
		this.formDatos = this.formBuilder.group({
			lista_rnt: ['', Validators.required],
		});
	}

	getRnt() {
		this.solicitudServices.getInformacionRnt(this.formDatos.value.lista_rnt).subscribe(resultado => {
			if (resultado.result) {
				const index = this.datosRnt.map(function (e) { return e.codigo_rnt; }).indexOf(resultado.data[0].codigo_rnt);
				if (index === -1) {
					this.datosRnt.push({ ...resultado.data[0] });
					this.formDatos.reset();
				} else {
					this.formDatos.reset();
				}
			}
		});
	}

	onEliminarRnt(item) {
		this.datosRnt.splice(this.datosRnt.indexOf(item), 1);
	}

	confirm(): void {
		if (this.activeModal && this.datosRnt) {
			this.activeModal.close(this.datosRnt);
		}
	}

	dismiss(): void {
		if (this.activeModal) {
			this.activeModal.dismiss();
		}
	}
}
